<template>
  <div class="home-main order-container bgc-gradient" style="padding-bottom: 1rem">
    <Header :is-nav="true" :title="headerTitle"></Header>
    <div class="main-container" style="position: static;overflow: auto;">
      <ProductList :searchData="orderList" @delCartItem="delCartItem" @rajs="rajs"></ProductList>
      <van-empty v-if="dataEmpty" class="custom-empty" description="暂无数据"></van-empty>
    </div>
    <div class="jsbottom">
      <div class="pice-info">
        <p>商品合计&nbsp;&nbsp;<span>¥{{ objItem.price ? objItem.price * objItem.quantity : 0 }}</span></p>
        <p>应付总价&nbsp;&nbsp;¥<span>{{ objItem.price ? objItem.price * objItem.quantity : 0 }}</span></p>
      </div>
      <div class="subbutton" @click="submit">
        下单结算
        <!-- <van-button type="danger" class="subbutton" @click="submit">下单结算</van-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header';
import ProductList from "./components/ProductList";
import cartApi from "@/request/cartApi"

export default {
  name: "Funds",
  components: {
    Header,
    ProductList,
  },
  data() {
    return {
      objItem: {},
      headerTitle: "购物车",
      filterFlag: false,
      orderList: [],
      sellers: [],
      brandList: [],
      searchForm: {
        categoryNameLevel1: "",
        categoryNameLevel2: "",
        keyword: "",
        owned: null,
        alive_flag: 1
      },
      hasNextPage: true,
      scrollParams: {
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: "",
        pullUpLoadNoMoreTxt: "",
      },
      formPage: {
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    statusType() {
      return this.$store.state.valueSet.NG_ORDER_STATUS;
    },
    orderType() {
      return this.$store.state.valueSet.NG_ORDER_TYPE;
    },
    dataEmpty() {
      return this.orderList.length == 0 && !this.loading;
    },
  },
  created() {
    this.getOrderList();
  },
  methods: {
    submit() {
      if (this.objItem.tradeId == undefined) {
        return this.$dialog.alert({
          message: '请您选择结算商品后再次操作',
        })
      }
      this.$router.push(`/planSale/OrderSubmit?tradeId=${this.objItem.tradeId}&stockId=${this.objItem.stockId}&stationName=${this.objItem.stationName}&stationCode=${this.objItem.stationCode}&quantity=${this.objItem.quantity}&price=${this.objItem.price}`)
    },
    rajs(item) {
      this.objItem = item;
    },
    async delCartItem(id) {

      cartApi.delCart(id).then((res) => {
        console.log(res)
        if (res.returnCode == '0') {
          this.getOrderList()
        } else {
          this.$dialog.alert({message: res.returnMessage})
        }
      })
    },
    onFilter() {
      this.filterFlag = !this.filterFlag;
    },
    //购物车列表加载
    async getOrderList() {
      cartApi.getValidCartList().then((res) => {
        console.log(res)
        if (res.returnCode == '0') {
          this.orderList = res.result
        }
      })
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>
<style lang="stylus" scoped>
.jsbottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 146px;
  background: #5b6d81;
  line-height: 80px;
  text-align: center;
  position: fixed;
  bottom: 0;
  z-index: 100;
  background: #FFFFFF;
  box-shadow: 0px -1px 0px 0px #EEEEEE;
  padding: 32px;
  box-sizing: border-box;

  .subbutton {
    width: 236px;
    height: 68px;
    line-height: 68px;
    background: #E0000C;
    border-radius: 40px 40px 40px 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #FFFFFF;
    text-align: center;
  }

  .pice-info {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #999999;

    p {
      margin: -25px 0;
    }

    p:nth-child(1) {
    }

    p:nth-child(2) {
      span {
        font-size: 28px;
        color: #FF5500;
      }
    }
  }
}

.home-main {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.list-wrapper {
  //height: auto;
}
</style>